(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .service("feedVisibility", feedVisibilityService);

  /** @ngInject */
  function feedVisibilityService() {
    var itemsToRemoveList = ["CURRENT_TIMEOUT_SEC"];

    this.removeFeeds = function (array) {
      return array.filter(function (feed) {
        return !itemsToRemoveList.includes(feed.reference);
      });
    };
  }
})();
